import { EntityTypes } from './entity-types';
import { FilterSortPageResponse, IGridRow } from "./grid.model";

export class Entity {
  cdsCode: string;
  countyCode: string;
  districtCode: string;
  schoolCode: string;
  status: string;
  name: string;
  charterNumber: string;
  type: EntityTypes;
  created: string;
  createdBy: string;
  lastModified: string;
  lastModifiedBy: string;
  lapsed: LapsedDistrict;

  constructor(init?: Partial<Entity>) {
    Object.assign(this, init);
  }
}

export class LapsedDistrict {
  newCDSCode: string;
  lapsedCDSCode: string;
  caFiscalYearStart: string;
}

export class EntitiesByTypeRequest {
  caFiscalYear: number;
  entityType: EntityTypes;

  constructor(init?: Partial<EntitiesByTypeRequest>) {
    Object.assign(this, init);
  }
}

export class EntityResponse extends Entity implements IGridRow   {
  rowId: string;
}

export class ViewItemsResponse extends FilterSortPageResponse<EntityResponse> { }
